module.exports = __webpack_public_path__ + "img/antes_despues_262.8dff336c.png";